import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@fontsource-variable/inter/opsz.css'
import '../style.css'
import 'vue-sonner/style.css'
import AdminApp from '@/AdminApp.vue'
import router from '@/router/admin'
import i18n from '@/locales'
import { useThemeStore } from '@/stores/theme'
import { installErrorTracking } from '@/lib/errorTracking'

const app = createApp(AdminApp)
installErrorTracking(app, 'admin')
app.use(createPinia())
// Applies the theme before the first route renders — signed-out pages carry no
// toggle, so nothing else would instantiate the store there.
useThemeStore()
app.use(router)
app.use(i18n)
app.mount('#app')
